import { render, staticRenderFns } from "./BusinessCategory.vue?vue&type=template&id=6dcfe413&scoped=true"
import script from "./BusinessCategory.vue?vue&type=script&lang=js"
export * from "./BusinessCategory.vue?vue&type=script&lang=js"
import style0 from "./BusinessCategory.vue?vue&type=style&index=0&id=6dcfe413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfe413",
  null
  
)

export default component.exports